import { QrReader } from "react-qr-reader";
import { useState, useEffect } from "react";
import React from "react";
import clsx from "clsx";
import ScannerTarget from '../svgComponents/ScannerTarget.jsx'

export const QRScanner= ({
  setInputValue,
  setIsCameraOpen,
  isCameraOpen,
  searchValue,
  setScannerError,
}) => {
  const [newSearchValue, setNewSearchValue] = useState("");
  const [isCameraActive, setIsCameraActive] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleScan = (data) => {
    if (data && data !== searchValue && isCameraOpen) {
      const cleanData = data.includes(":") ? data.split(":").pop() : data;

      cleanData && setNewSearchValue(cleanData);
    }
  };

  const handleError = (error) => {
    if (error?.message?.includes("denied")) {
      setIsError(true);
    }

    if (error && error.name === "NotAllowedError") {
      setIsCameraActive(false);
    } else if (error && error.name === "NotFoundError") {
      setIsCameraActive(false);
    } else {
      setIsCameraActive(true);
    }

    console.error(error);
  };

  useEffect(() => {
    if (isCameraOpen) {
      if (newSearchValue && newSearchValue !== searchValue) {
        setIsCameraOpen(false);

        setInputValue(newSearchValue);
      }

      if (isError) {
        setTimeout(() => {
          setScannerError(true);

          setTimeout(() => {
            setScannerError(false);
          }, 3000);

          setIsCameraOpen(false);

          setIsError(false);
        }, 250);
      }
    }
  }, [isCameraOpen, newSearchValue, isError]);

  return (
    <div
      className={clsx(
        "w-full h-dvh fixed z-[100] top-0 left-0",
        isCameraActive && "backdrop-blur-sm"
      )}
      onClick={() => setIsCameraOpen(false)}
    >
      {isCameraOpen && (
        <QrReader
          onResult={(result, error) => {
            if (result) {
              handleScan(result.getText());
            }

            if (error) {
              handleError(error);
            }
          }}
          ViewFinder={() => (
            <div>
              <ScannerTarget className="absolute z-[100] top-1/2 left-1/2 w-[250px] h-[250px] -translate-x-1/2 -translate-y-1/2 text-white" />
            </div>
          )}
          className={clsx(
            "relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-20",
            !isCameraActive && "hidden"
          )}
          constraints={{ facingMode: "environment" }}
        />
      )}
    </div>
  );
};
